module.exports = __webpack_public_path__ + "img/van.4fb07b91.png";